module.exports = __webpack_public_path__ + "static/media/Ngramu Jamoe.d2ea0e84.jpeg";